<style>
	.bg663 {
		background-color: #fff;width:100%; 
	}
 
 
.draw-enter-active, .draw-leave-active {
     transition: opacity 0.2s;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
}
.top_area{width:100%;height:4vw;position:fixed;top:1vw;left:0; }
.top_area img{display:block;float:left;height:4vw; }
.tabbar11{width:84vw;height:4vw;background:url(../../assets/images/tabbar_bg.png) center center; border-radius:.5vw;
float:left;margin-left:2.5vw;background-size:105% 105%;cursor:pointer; }
.tabbar11 span{display:block;float:left;line-height:4vw;font-size:1.4vw;}
.tabbar11 span.pos{ padding:0 1vw;}
.tabbar11 span.floder{  color:#3268ff;}
.tabbar11 span.rights{background:url(../../assets/images/right.png) no-repeat;width:2vw;
height:4vw;background-position:center center;background-size:2vw;}
.result_list{width:84vw;margin-left:7vw;margin-top:7vw;min-height:10vw;border:#ddd solid 1px;border-radius:.5vw;box-sizing:border-box;}
.lists_top{width:100%;height:8vw;border-bottom:#ddd solid 1px;}
.lists_top_left{width:59vw;float:left;height:100%;position:relative;box-sizing:border-box;}
.lists_top_left img{display:block;position:absolute;left:2vw;top:2vw;width:3vw;}
.lists_top_left span{display:block;position:absolute;}
.lists_top_left span.r1{top:2.2vw;left:5vw;font-size:1.3vw;color:#0F7A3E;}
.lists_top_left span.r2{top:4.2vw;left:5vw;font-size:1vw;color:#999;border:#ddd solid 1px;line-height:2vw;padding:0 .5vw;border-radius:.5vw;}
.lists_top_middle{width:10vw;height:100%;border-right:#ddd solid 1px;float:right;box-sizing:border-box;border-left:#ddd solid 1px;}
.lists_top_middle span{display:block;height:2.65vw;line-height:2.65vw;text-align:left;border-bottom:#ddd solid 1px;width:8vw;padding:0 1vw;font-size:1vw;
 color:#333;}
 
.lists_top_right{width:14vw;height:100%; float:right;box-sizing:border-box;}
.lists_top_right span{display:block;height:2.65vw;line-height:2.65vw;text-align:left;border-bottom:#ddd solid 1px;width:12vw;padding:0 1vw;font-size:1vw;
 color:#333;}
.lists_top_right span.mn2{color:#0F7A3E;}
.lists_top_right span.mn3{color:#f00;}

.table_title{width:100%;height:3vw;background:#fff1f1;}
.table_title span{display:block;float:left;font-size:1vw;line-height:3vw;text-align:left;}
.table_title span.t1{width:15%;padding-left:5%;}
.table_title span.t2{width:10%;}
.table_title span.t3{width:20%;}
.table_title span.t4{width:20%;}
.table_title span.t5{width:20%;padding-right:5%;}
.result_list ul{width:100%;height:20vw;overflow-y:scroll;}
.result_list ul li{width:100%;height:3vw;}
.result_list ul li span{display:block;float:left;font-size:1vw;line-height:3vw;text-align:left;}
.result_list ul li span.t1{width:15%;padding-left:5%;}
.result_list ul li span.t2{width:10%;}
.result_list ul li span.t3{width:20%;}
.result_list ul li span.t4{width:20%;}
.result_list ul li span.t5{width:20%;padding-right:5%;}

.pages{margin:0 auto;padding:0;overflow:hidden;width:84vw;height:4vw; margin-top:2vw;} 
.pre{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;}
.pre img{width:2vw;margin-top:.25vw;margin-left:.2vw;}
 
.next{width:2.5vw;height:2.5vw;border:#e0e0e0 dotted 1px;float:left;box-sizing:border-box;margin-left:1vw;}
.next img{width:2vw;margin-top:.25vw;margin-left:.25vw;}

.submits2111{width:12vw;height:4vw;border-radius:.5vw;float:right;background:#ccc;}
.submits2111 button{background:#3268ff;outline:none;border:0;font-size:1.2vw;display:block;height:4vw;line-height:4vw;width:100%;color:#fff;border-radius:.5vw;}
table{width:100%; }
table th{height:3vw;line-height:3vw;font-size:1.2vw;text-align:center;background:#fff1f1;}
table td{height:3.5vw;line-height:3.5vw;font-size:1.2vw;text-align:center;}
 .boxs{height:25vw;overflow-y:scroll;width:84vw;}

 .action_box{width: 80vw;height: 3vw;margin: 0 auto;padding: 0;overflow: hidden;}
 .action_box input{width: 1.2vw;height: 1.2vw; margin-top: .9vw;display: block;float: right;padding: 0 1vw;}
 .action_box label{line-height: 3vw;display: block;float: right;padding-right: 1vw;font-size: 1.2vw;}
 .action_box button{display: block;padding: 0 1vw;height: 2vw;border:none;margin-top: .5vw;background:#3465ff;color: #fff;border-radius: .3vw;
 	float: right;font-size: 1.2vw;}
 .action_box span{display: block;padding: 0 1vw;font-size: 1.2vw;float: right;line-height: 3vw;cursor: pointer;color: #3465ff;text-decoration: underline;}
</style>
 
<template>
	<div class="bg663">
		     
	     <u_center  ></u_center>
	     <div class="top_area">
		    <img @click="home()" src="../../assets/images/home_icon.png">
			<div class="tabbar11">
			   <span class="pos">您的当前位置:</span>
			   <span class="floder">发送记录</span>
			   <span class="rights"></span>
			   <span class="floder">发送失败列表</span>
			   
			</div>
		 </div>
		 <div class="result_list">
		    <div class="lists_top">
			   <div class="lists_top_left">
			       <img src="../../assets/images/excel.png">
				   <span class="r1">{{name}}</span>
				   <span class="r2">{{year}}年-{{zs_category}}-{{grade}}-{{category}}-{{area}}-录取名单</span>
			   </div>
			   <div class="lists_top_right">
			      <span class="mn1">{{success+failed}}</span>
				  <span class="mn2">{{success}}</span>
				  <span class="mn3" style="border-bottom:0;">{{failed}}</span>
			   </div>
			   <div class="lists_top_middle">
			      <span class="m1">发送总条数</span>
				  <span class="m2">发送成功</span>
				  <span class="m3" style="border-bottom:0;">发送失败</span>
			   </div>
			</div><div class="boxs">
			<table border="0"  >
			  <tr style="border-bottom:#ddd solid 1px;">
				<th style="width: 20%;font-weight: bold;border-right:#ddd solid 1px;">发送时间</th>
				<th style="width: 20%;font-weight: bold;border-right:#ddd solid 1px;">接收号码</th>
				<th style="width: 35%;font-weight: bold;border-right:#ddd solid 1px;">失败原因</th>
				<th style="width: 20%;font-weight: bold;border-right:#ddd solid 1px;">后续处理</th>
				<th style="width: 5%;font-weight: bold">选择</th>
			  </tr>
			  
				  <tr v-for="item in list" class="con" style="border-bottom:#ddd solid 1px;">
					<td    style="width: 20%;border-right:#ddd solid 1px;">{{item.time|formatDate}}</td>
					<td    style="width: 20%;border-right:#ddd solid 1px;font-size: 1.5vw;">{{item.phone|sub_phone}}</td>
					<td  v-if="item.has_result"  style="width: 35%;border-right:#ddd solid 1px;">{{item.result}}</td>
					<td  v-else  style="width: 35%;border-right:#ddd solid 1px;">/</td>
					<td    style="width: 20%;color:#999;border-right:#ddd solid 1px;" v-if="item.mark==0">未作处理</td>
					<td    style="width: 20%;color:#3465ff;border-right:#ddd solid 1px;" v-else-if="item.mark==1">已通过其他方式联系</td>
					<td    style="width: 20%;color:#c00;border-right:#ddd solid 1px;" v-else-if="item.mark==2">未能联系到本人</td>
					<td    style="width: 5%"><input type="checkbox" v-model="item.check"></td>
				  </tr>
			  
			</table></div>

 
		 </div> 
		 <div class="action_box">
                <button @click="actions()">操作</button>
                <label>未能联系到本人</label>
                <input type="radio" name="methods" v-model="methods" value="2">
                <label>已通过其他方式联系</label>
                <input type="radio" name="methods" v-model="methods" value="1" checked>
                
                <span @click="unsel()">取消全选</span>
                <span @click="sel()">全选</span>
		 </div>
		  <div class="pages">
		    <div class="pre">
			   <img src="../../assets/images/pre1.png">
			</div>
			<div class="next">
			   <img src="../../assets/images/next1.png">
			</div>
			<div class="submits2111">
		        <button @click="store()">上一步</button>
		     </div>
		 </div>
		 

	</div>
</template>
<script>
import u_center from '@/components/u_center.vue'; 
	export default {
	    components: {
		  u_center,
	    },
		data() {
			return {
				 id:"",
				 list:[],
				 success:0,
				 failed:0,
				 name:"",
				 year:"",
				 zs_category:"",
				 grade:"",
				 category:"",
				 area:"",
				 head:[],
				 width:"",
				 template:"",
				 methods:1,
			}
		},filters: {
				 formatDate: function(value) {
					var date = new Date();
					 date.setTime(value*1000);
					var month = date.getMonth() + 1;
					var hours = date.getHours();
					if (hours < 10)
						hours = "0" + hours;
					var minutes = date.getMinutes();
					if (minutes < 10)
						minutes = "0" + minutes;
					var time = date.getFullYear() + "-" + month + "-" + date.getDate() +" "+hours+":"+minutes   ;
					return time;
				},sub_phone(value){
                       return  value.substr(0,3)+"-"+value.substr(3,4)+"-"+value.substr(7,4);
				}
			},
		mounted() {
		      let self=this;
			  this.id = this.$utils.getUrlKey('id');	
			  this.template = this.$utils.getUrlKey('template');	
		      var token= localStorage.getItem("token");
			  if(!token){
					 self.$router.push("/");  
			  }else{
			      self.token=token;
				  self.get_import_results3();
			  }  
		},
		methods: {
		    sel(){
                    var new_list=[];                   
				this.list.forEach(function(obj,index){
					new_list[index]=obj;
					new_list[index].check=true;
				});
			    this.list=new_list;
		    },
		    unsel(){
                    var new_list=[];                   
				this.list.forEach(function(obj,index){
					new_list[index]=obj;
					new_list[index].check=false;
				});
			    this.list=new_list;
		    },
		    actions(){
	 
                  let self=this;
				  axios.post(this.$api+'/message/get_send_results_failed_mark', {
						   token:self.token,
						   res_id:self.id,
						   list:JSON.stringify(self.list),
						   methods:self.methods
				  }).then(function (response) {  
					  let data=response.data;
					  if(data.state==1){                
						self.get_import_results3();     
					  }else{
					  	self.$toast.center(data.msg);
					  }
				  }).catch(function (error) {
						 
				  });
		    },
		    send_results(){
		      if(this.id){
			     if(this.template){
				   this.$router.push("/store?id="+this.id+'&template='+this.template);  
				 }else{
				   this.$router.push("/store?id="+this.id);  
				 }
			     
			  }else{
			      this.$router.push("/store");  
			  }
		   },
		    home(){
			  this.$router.push("/");  
			},
			store(){
			  this.$router.push("/send_history");  
			},
		     get_import_results3(){	        
				  let self=this;
				  axios.post(this.$api+'/message/get_send_results_failed', {
						   token:self.token,
						   res_id:self.id
				  }).then(function (response) {  
					  let data=response.data;
					  if(data.state==1){                
						    self.list=data.data.list;
							self.success=data.data.success;
							self.failed=data.data.failed;
                            self.name=data.data.name;	
                                       self.year=data.data.year;
									   self.zs_category=data.data.zs_category;
									   self.grade=data.data.grade;
									   self.category=data.data.category;
									   self.area=data.data.area;
									   self.head=data.data.head;
									   self.width="width:"+data.data.width+"%";
									   							
					  } 
				  }).catch(function (error) {
						 
				  });
		    }, 
		     
		},watch:{
			 
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/sms/view_results3.vue